import React,{useState} from 'react'
import { Link as RouterLink} from 'react-router-dom'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function SignUpPage(){
    const [data, setData] = useState('')
    const [msg, setMsg] = useState('')
    const [signupBtn, setSignupBtn] = useState(false)
    const onChangeInput = ({ currentTarget: input }) => { setData({ ...data, [input.name]: input.value }) }
    const onClick2SignUp = async() =>{
        setSignupBtn(true)
        setMsg('Please wait for a moment..')
        let x = []
        for(let i = 0; i < data.pwd.length; i++){
            x.push('*')
        }
        const { data: res } = await axios.post(`${APIURL}/signup`, {...data, 'id':`${Math.random().toString(36).substring(2)}`, 'pwdlen':x.join(''),'confirmed':`${Math.random().toString(36).substring(2)}`,'plan':'free'})
        setMsg(res.msg)
    }
    return(
        <>
        <div className='mt-4 m-auto max-w-[650px] structure__login__container'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Sign Up</h2>
        <div className='md:m-auto flex w-fit structure__login__input__container'>
        <div className='flex-col w-[80px] text-right mr-1 bitter'><div className='text-[11px] mt-[6px] mb-[8px]'>Email</div><div className='text-[11px] mt-[14px] mb-[14px]'>Password</div></div>
        <div className='flex-col text-left w-fit md:w-[362px]'>
        <input name='email' className='border-[1px] border-gray-800 structure__login__input w-full md:w-96 bitter' onChange={onChangeInput}/>
        <input name='pwd' className='mt-1 border-[1px] border-gray-800 structure__login__input w-full md:w-96 bitter' onChange={onChangeInput}/>
        <div className='mt-1 flex w-full text-center'><button className='hover:bg-[#365c88] disabled:bg-[#dcdcdc] disabled:border disabled:border-gray-200 bg-[#414c75] h-[28px] text-[13px] pl-[12px] pr-[12px] text-white m-auto font-medium bitter' onClick={onClick2SignUp}  disabled={signupBtn}>Register</button></div>
        <div className='text-center text-[12px] bitter'>{msg}</div>
        <div className='bitter text-center'><RouterLink className='ext-center underline text-[9px]' to='/login'>Already have account? Back to Login.</RouterLink></div>
        </div>
        </div>
        <br/><br/>
        </div>
        {/* <TmpSubscriptionJS/> */}
        </>
     )
}
export function TmpSubscriptionJS() {
    return(
        <div>
        <div className='structure__main__subttl'>Subscription</div>
        <div className='structure__subscribe__container'>
            <div className='mt-4 structure__subscribe__item'>
                <h3>Free Account</h3>
                <span>Free</span><br/><br/>
                · all demo access<br/>
                <div>
                <button className='mt-4 primary-btn'>Select this as your plan</button>
                </div>
            </div>
            <div className='mt-4 structure__subscribe__item'>
                <h3>Developer Account</h3>
                <span>$35/month</span><br/><br/>
                · all demo access<br/>
                · react codes access<br/>
                <button className='mt-4 primary-btn'>Select this as your plan</button>
            </div>
            <div className='mt-4 structure__subscribe__item'>
                <h3>Pro Developer Account</h3> 
                <span>$78/month</span><br/><br/>
                · all demo access<br/>
                · all codes access<br/>
                · react codes access<br/>
                · next codes access<br/>
                · node codes access<br/>
                · python codes access<br/>
                <button className='mt-4 primary-btn'>Select this as your plan</button>
            </div>
        </div>
        </div>
    )
}